import { SortInput } from 'components/Table'
import { PageSortBy } from './types'

export const DEFAULT_SORT: SortInput<PageSortBy> = {
  by: 'domain.name',
  direction: 'asc',
} as const

export const SORTABLE_COLUMNS: PageSortBy[] = ['domain.name', 'name', 'updatedAt']
